import React, { useCallback, useLayoutEffect, useMemo } from 'react';
import { StyleSheet } from 'react-native';
import Animated from 'react-native-reanimated';
import { FlashList } from '@shopify/flash-list';
import { useAppSelector } from 'store/hooks';
import { AppView, rem, SCROLL_INDICATOR_INSETS, withAnimatedNavigationHeader, } from 'design-system';
import Button, { HEIGHT_PLUS_PADDING } from 'design-system/Button';
import ScreenInfoHeader from 'design-system/ScreenInfoHeader';
import StatusBar from 'design-system/StatusBar';
import useAppFrameDimensions from 'hooks/useAppFrameDimensions';
import { useMarginBottom } from 'hooks/useMarginBottom';
import HelpScreenButton from 'features/help/components/HelpScreenButton';
import { selectWealthBalanceInfo, } from 'features/wealth/selectors';
import WealthInfoRow from './components/WealthInfoRow';
const AnimatedFlashList = Animated.createAnimatedComponent(FlashList);
const DeleteWealthBalanceInfoScreen = withAnimatedNavigationHeader(({ scrollHandler, navigation }) => {
    useLayoutEffect(() => {
        navigation.setOptions({
            headerRight: () => <HelpScreenButton />,
        });
    }, []);
    const onPressBack = useCallback(() => {
        navigation.popToTop();
    }, []);
    const { paddingHorizontalStyle } = useAppFrameDimensions();
    const contentContainerStyle = useMarginBottom('paddingBottom', HEIGHT_PLUS_PADDING, paddingHorizontalStyle);
    const wealthBalanceInfo = useAppSelector(selectWealthBalanceInfo);
    const ListHeaderInfo = useMemo(() => (<ScreenInfoHeader style={styles.screenInfoHeader} title="You can’t close your account yet" subTitle="Make sure all your money has been withdrawn and any pending transactions are complete before closing your account"/>), []);
    const renderItem = useCallback(({ item }) => <WealthInfoRow item={item}/>, []);
    return (<AppView withFrame={false}>
          <StatusBar barStyle="dark-content" animated/>

          <AnimatedFlashList renderItem={renderItem} onScroll={scrollHandler} scrollEventThrottle={16} data={wealthBalanceInfo?.data} ListHeaderComponent={ListHeaderInfo} contentContainerStyle={contentContainerStyle} scrollIndicatorInsets={SCROLL_INDICATOR_INSETS}/>

          <Button brand floating title="Close" onPress={onPressBack}/>
        </AppView>);
}, ({ colors }) => ({
    headerColorOutputRange: [
        colors.background.dark,
        colors.cards.onDark,
    ],
}));
const styles = StyleSheet.create({
    screenInfoHeader: {
        paddingBottom: rem(8),
    },
});
export default DeleteWealthBalanceInfoScreen;
